import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';
import { MaintenanceStrategy } from '../maintenance-strategies/maintenance-strategy';
import { ChildDataTableItem } from '../child-data-table-item';

export class PlannedMaintenanceMaintenanceStrategy implements ViewModel, ChildDataTableItem {
  readonly friendlyTypeNameSingular: string = 'Planned Maintenance Maintenance Strategy';
  readonly apiRoute: string = CONFIG.apiRoutes.plannedMaintenanceLibrary;

  id: string;
  reference: string;
  title: string;
  maintenanceStrategyId: string;
  plannedMaintenanceLibraryItemId: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.reference = data.reference;
    this.title = data.title;
    this.maintenanceStrategyId = data.maintenanceStrategyId;
    this.plannedMaintenanceLibraryItemId = data.plannedMaintenanceLibraryItemId;
  }

  loadFromLibraryItem(maintenanceStrategy: MaintenanceStrategy): any {
    this.reference = maintenanceStrategy.reference;
    this.title = maintenanceStrategy.title;
    this.maintenanceStrategyId = maintenanceStrategy.id;
  }

  areForeignKeysEqual(other: PlannedMaintenanceMaintenanceStrategy): boolean {
    return other.maintenanceStrategyId === this.maintenanceStrategyId && other.plannedMaintenanceLibraryItemId === this.plannedMaintenanceLibraryItemId;
  }
}
